import React from 'react';

import { flattenEntry, getEntries } from '@/lib/cms';

import { JobType, OpenPositionsItemProps } from './OpenPositionsItem';
import OpenPositionsItem from './OpenPositionsItem';

export type OpenPositionsListProps = {
  pages?: OpenPositionsItemProps[];
};
interface HeroInfo {
  jobType: JobType;
  city: string;
}

export async function OpenPositionsList({ pages }: OpenPositionsListProps) {
  const sortedPages = pages?.sort((a, b) => a.slug.localeCompare(b.slug));
  const entries = await getPages(sortedPages);

  const pageInfo: HeroInfo[] = entries
    ?.sort((a, b) => a.slug.localeCompare(b.slug))
    ?.map((entry) =>
      entry.blocks.find((block) => block.__component === 'hero.careers-hero')
    )
    ?.filter(Boolean)
    ?.map((hero) => ({
      jobType: hero?.jobType,
      city: hero?.city,
    })) as HeroInfo[];

  const page = sortedPages?.map((item, index) => {
    const correspondingPageInfo = pageInfo[index];

    return (
      <OpenPositionsItem
        key={index}
        {...item}
        jobType={correspondingPageInfo?.jobType}
        city={correspondingPageInfo?.city}
      />
    );
  });

  if (!page || (Array.isArray(page) && page.length === 0)) {
    return (
      <p className='border-neutral-N20 text-body-l text-neutral-N80 w-full border-t py-6 text-left font-sans'>
        No open positions at this time
      </p>
    );
  }

  return <div className='border-neutral-N20 w-full border-b'>{page}</div>;
}

async function getPages(pages: OpenPositionsListProps['pages']) {
  const entries = await getEntries({
    contentType: '/pages',
    query: {
      filters: {
        slug: pages?.map((page) => page.slug) || [],
      },
      populate: {
        blocks: {
          on: {
            'hero.careers-hero': {
              populate: '*',
            },
          },
        },
      },
    },
  });

  if (!entries?.data) return;

  return entries.data.map(flattenEntry);
}
